interface TmsConfig {
  downloadUrl: string;
  unzipDir: string;
  tmsRepo: string;
  devFilePath: string;
  buildPath: string;
  unzipFilePath: string;
}

import config from '../tms.config.json';

export const tmsConfig: TmsConfig = config;

export const getTmsPath = (locale: string) => {
  const { tmsRepo, devFilePath } = tmsConfig;
  const filePath = devFilePath
    .replace(`{locale}`, locale)
    .replace(`{tmsRepo}`, tmsRepo);
  const pathList = filePath.split('/');
  pathList.shift();
  pathList.shift();
  pathList.shift();
  return `/${pathList.join('/')}`;
};

export const getTmsServerPath = (locale: string) => {
  const { tmsRepo, unzipDir, unzipFilePath } = tmsConfig;
  const filePath = unzipFilePath
    .replace(`{locale}`, locale)
    .replace(`{tmsRepo}`, tmsRepo);

  return `${unzipDir}/${filePath}`;
};

// export const loadLangInServer = async (locale: string, entry: string) => {
//   const path = getTmsServerPath(locale);
//   const dirArr = __dirname.split('/app').shift();
//   // dirArr.pop();
//   // dirArr.pop();
//   // const a = dir.split('/');
//   const fullPath = `${dirArr}/${path}`;
//   // console.log('entry:', fullPath, entry);
//   return require(fullPath);
// };
